import axios from 'axios'
import React, { useEffect, useState } from 'react'

export default function Data() {

    const [subscribers,getSubscriber] = useState('[]')
    useEffect(() => {
      axios.get('/.netlify/functions/livedata')
        .then(res => getSubscriber(res.data))
        .catch((err)=> console.log(err))
    }, []) 
 
    return (

        <table className="w-full border-collapse">
    <thead>
        <tr>
            <th className="hidden p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">Email</th>
            <th className="hidden p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">Timestamp</th>
        </tr>
    </thead>
    <tbody>
                    {
                        
                    Object.values(subscribers).map((subscriber) => {
                        return (
                            <>
                                <tr className="flex flex-row flex-wrap mb-10 bg-white lg:hover:bg-gray-100 lg:table-row lg:flex-row lg:flex-no-wrap lg:mb-0">
                                    <td className="relative block w-full p-3 text-center text-gray-800 border border-b lg:w-auto lg:table-cell lg:static">
                                    <span className="absolute top-0 left-0 px-2 py-1 text-xs font-bold uppercase bg-blue-200 lg:hidden">Email</span>
                                        {subscriber.email}
                                    </td>
                                    <td className="relative block w-full p-3 text-center text-gray-800 border border-b lg:w-auto lg:table-cell lg:static">{Date(subscriber.timestamp)}</td>
                                </tr>
                            </>
                        )
                    })
                    }
                </tbody>
            </table>

    )
}
